<template>
  <header
    v-show="showHeader"
    class="head ljb-border">
    <span
      :class="{back:!BackArrow}"
      @click="back"/>
    {{ title }}
  <slot/></header>
</template>

<script>
export default {
  name: 'LjbHeader',
  props: {
    title: {
      type: String,
      default: ''
    },
    BackArrow: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showHeader: false
    }
  },
  methods: {
    back () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
  .head{
    background:#fff;
    color: #333;
    text-align: center;
    padding: 14px;
    font-size: 18px;
    position: relative;
    .back{
      position: absolute;
      width: 12px;
      height: 20px;
      top:18px;
      left:12px;
      background: url('https://cdn.51ljb.cn/ljb-arrow_back.png') no-repeat;
      background-size: 12px 16px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/LjbHeader.vue